module.exports = __webpack_public_path__ + "img/1072265059.55746a38.jpg";